import { m as unwrapJSON, b as addressToHex, g as toUpperCase, u as upperTrim, j as isEmptyString, t as trim, i as isEmpty, n as wrapToString } from './minimark.92cd751b.mjs';
import { nanoid } from 'nanoid';

const SQUARE = "::";
const RMRK = /^[rR][mM][rR][kK]::/;
const RMRK_PLUS = new RegExp(RMRK.source + "[A-Z]+" + SQUARE + "([0-2].0.[0-1])" + SQUARE);
const RMRK_V0 = "0.0.1";
const RMRK_V1 = "1.0.0";
const RMRK_V2 = "2.0.0";

var Interaction$1 = /* @__PURE__ */ ((Interaction2) => {
  Interaction2["MINT"] = "MINT";
  Interaction2["MINTNFT"] = "MINTNFT";
  Interaction2["LIST"] = "LIST";
  Interaction2["UNLIST"] = "UNLIST";
  Interaction2["BUY"] = "BUY";
  Interaction2["SEND"] = "SEND";
  Interaction2["CONSUME"] = "CONSUME";
  Interaction2["CHANGEISSUER"] = "CHANGEISSUER";
  Interaction2["EMOTE"] = "EMOTE";
  return Interaction2;
})(Interaction$1 || {});

var Interaction = /* @__PURE__ */ ((Interaction2) => {
  Interaction2["ACCEPT"] = "ACCEPT";
  Interaction2["BASE"] = "BASE";
  Interaction2["EQUIP"] = "EQUIP";
  Interaction2["EQUIPPABLE"] = "EQUIPPABLE";
  Interaction2["LOCK"] = "LOCK";
  Interaction2["RESADD"] = "RESADD";
  Interaction2["SETPROPERTY"] = "SETPROPERTY";
  Interaction2["SETPRIORITY"] = "SETPRIORITY";
  Interaction2["THEMEADD"] = "THEMEADD";
  Interaction2["BUY"] = "BUY";
  Interaction2["EMOTE"] = "EMOTE";
  Interaction2["CHANGEISSUER"] = "CHANGEISSUER";
  Interaction2["SEND"] = "SEND";
  Interaction2["LIST"] = "LIST";
  Interaction2["UNLIST"] = "UNLIST";
  Interaction2["CREATE"] = "CREATE";
  Interaction2["MINT"] = "MINT";
  Interaction2["BURN"] = "BURN";
  Interaction2["DESTROY"] = "DESTROY";
  return Interaction2;
})(Interaction || {});

const isRemark = (text) => {
  return RMRK.test(text);
};
const isRemarkVersion = (text) => {
  return text.match(RMRK_PLUS)?.at(1);
};
const splitBySquare = (text) => text.split(SQUARE);
const isValidInteraction = (interaction, throwable = true) => {
  const availableInteractions = [...Object.values(Interaction$1), ...Object.values(Interaction)];
  const value = availableInteractions.includes(interaction);
  if (!value && throwable) {
    throw new TypeError(`RMRK: Invalid interaction ${interaction}`);
  }
  return value;
};
const toInteraction = (interaction) => {
  isValidInteraction(interaction);
  return interaction;
};
const isCreateInteraction = (interaction) => {
  return interaction === Interaction$1.MINT || interaction === Interaction$1.MINTNFT;
};
const toVersion = (version) => {
  if (!version) {
    return "1.0.0";
  }
  return version;
};
const resolveValue = (interaction, mayIdOrValue, mayValue) => {
  if (isCreateInteraction(interaction)) {
    const value = unwrapJSON(mayIdOrValue);
    if (!value) {
      throw new TypeError(`RMRK: Unable to unwrap value ${mayIdOrValue}`);
    }
    return value;
  }
  if (!mayIdOrValue) {
    throw new TypeError(`RMRK: Unable to ${interaction} unwrap value ${mayIdOrValue}`);
  }
  return {
    id: mayIdOrValue,
    value: mayValue
  };
};

const toSerialNumber = (index, offset = 0, plusOne = true) => {
  return String(index + offset + Number(plusOne)).padStart(16, "0");
};
function toCollectionId(caller, symbol) {
  if (!caller) {
    throw new ReferenceError("[RMRK] Could not create collection, because caller is empty");
  }
  const pubkey = addressToHex(caller);
  return (pubkey?.substr(2, 10) + pubkey?.substring(pubkey.length - 8) + "-" + (symbol || "")).toUpperCase();
}
const makeSymbol = (symbol) => {
  return !symbol ? toUpperCase(nanoid(13)) : upperTrim(symbol, true);
};
const toNFTId = (collectionId, symbol, sn, blocknumber) => {
  if (isEmptyString(collectionId) || isEmptyString(symbol) || isEmptyString(sn)) {
    throw new ReferenceError("[MINIMARK] toNFTId: invalid nft");
  }
  return `${blocknumber}-${collectionId}-${symbol}-${sn}`;
};
const findUniqueSymbol = (symbol, usedSymbols) => {
  const result = symbol || makeSymbol();
  const hasSymbol = usedSymbols.includes(result);
  if (!hasSymbol) {
    return result;
  }
  return findUniqueSymbol(void 0, usedSymbols);
};

const makeCollection = (caller, symbol, name, metadata, max = 0) => {
  if (max < 0) {
    throw new Error("max should be equal or greater than zero");
  }
  const theSymbol = makeSymbol(symbol);
  return {
    id: toCollectionId(caller, theSymbol),
    symbol: theSymbol,
    issuer: caller,
    name: trim(name),
    max,
    metadata
  };
};
const makeInteraction = (action, version, objectId, meta) => {
  if (!objectId || objectId === "") {
    throw new ReferenceError(`[${action}] Could not create, because NFT ID is empty`);
  }
  return `RMRK::${action}::${version}::${objectId}${meta ? "::" + meta : ""}`;
};
const makeCreateInteraction = (action, version, object) => {
  if (isEmpty(object)) {
    throw new ReferenceError(`[${action}] Could not create, because ${object} is empty`);
  }
  return `RMRK::${action}::${version}::${wrapToString(object)}`;
};

export { Interaction$1 as I, RMRK as R, SQUARE as S, RMRK_PLUS as a, RMRK_V0 as b, RMRK_V1 as c, RMRK_V2 as d, isRemarkVersion as e, isValidInteraction as f, isCreateInteraction as g, toVersion as h, isRemark as i, toSerialNumber as j, toCollectionId as k, toNFTId as l, makeSymbol as m, findUniqueSymbol as n, makeCollection as o, makeInteraction as p, makeCreateInteraction as q, resolveValue as r, splitBySquare as s, toInteraction as t, Interaction as u };
